<template>
  <p
    :class="
      type === 'form-label'
        ? 'text-sm text-grey700'
        : type === 'table-text-normal'
        ? 'text-grey600 text-xs'
        : type === 'table-text-head'
        ? 'text-grey600 text-sm'
        : type === 'mainText'
        ? 'text-2xl font-semibold font-inter'
        : type === 'textFadedLight'
        ? 'text-foundationGrey500 text-sm'
        : type === 'textFadedMedium'
        ? 'text-foundationGrey900 text-base'
        : type === 'subHeader'
        ? 'text-grey900 font-semibold text-lg'
        : type === 'tableTitle'
        ? 'my-4 text-sm font-semibold'
        : type === 'little-text-bold'
        ? 'text-base text-grey700'
        : 'text-black'
    "
  >
    {{ text }}
  </p>
</template>

<script>
export default {
  props: ["type", "text"],
};
</script>

<style></style>
